"use strict";

exports.__esModule = true;
exports.TPA_EXPERIMENTS = void 0;
const TPA_EXPERIMENTS = exports.TPA_EXPERIMENTS = {
  USE_BLOCKS_PLAN_LIST_WIDGET: 'specs.membership.UseBlocksPlanListWidget',
  USE_BLOCKS_PACKAGE_PICKER_PAGE: 'specs.membership.UseBlocksPackagePickerPage',
  INSTALL_SPLIT_PAGES: 'specs.membership.InstallSplitPages',
  ROUTER: 'specs.membership.EnableRouter',
  ROUTER_MIGRATION: 'specs.membership.RouterMigration',
  USE_CURRENCY_FORMATTER: 'specs.membership.useCurrencyFormatterInPresenter',
  ROUTE_PAYWALL: 'specs.membership.RoutePaywall',
  USE_WARM_UP_DATA_BLOCKS: 'specs.membership.UseWarmUpDataInBlocks',
  ON_LOGIN_RETRY_FOR_SAFARI: 'specs.membership.OnLoginRetryForSafari',
  STUDIO_MOBILE_SETTINGS_MIGRATION: 'specs.membership.StudioMobileSettingsMigration',
  SHOW_NO_PAGE_FIX_MODAL: 'specs.membership.ShowNoPageFixModal',
  BLOCKS_NAVIGATION_FIX: 'specs.membership.BlocksNavigationFix',
  TAX_NAME_LIVE_SITE: 'specs.membership.TaxNameInLiveSite',
  VALIDATE_PLAN_IDS: 'specs.membership.ValidatePlanIds',
  SINGLE_PLAN_IMAGE_FIX: 'specs.membership.SinglePlanWidgetImageFix',
  WAIT_FOR_ORDER_PROVISION: 'specs.membership.WaitForOrderProvision'
};
//# sourceMappingURL=tpa.js.map